__turbopack_context__.v({
  "container": "debugging-info-module-scss-module__ky8I2q__container",
  "explainButton": "debugging-info-module-scss-module__ky8I2q__explainButton",
  "highlight": "debugging-info-module-scss-module__ky8I2q__highlight",
});
